<template>
  <div class="product-list">
    <el-form :inline="true">
      <el-form-item>
        <el-select
          placeholder="客户名称"
          v-model="searchForm.customer_name"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in $store.state.customerNameList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="产品名称"
          @change="productChange"
          v-model="searchForm.product_name"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in $store.state.productNameList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="产品规格"
          v-model="searchForm.product_size"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in $store.state.productSizeList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="
            searchForm.page = 1;
            getList();
          "
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <el-row style="margin-bottom: 15px">
      <el-button size="small" type="success" @click="addProductVisible = true"
        >添加产品</el-button
      >
      <CreateCustomerOrderButton :selectList="selectList" v-if="false" />
      <CreateProduceButton :selectList="selectList" />
      <CreateProduceReportButton :selectList="selectList" />
      <el-button
        style="float: right"
        size="small"
        icon="el-icon-download"
        v-show="false"
        >另存为Excel</el-button
      >
    </el-row>
    <el-alert type="success" :closable="false" style="margin-bottom: 15px">
      <div slot="title">
        <span style="line-height: 35px">已选产品:</span>
        <span v-if="selectList.length === 0">无</span>
        <span v-else>
          <el-tag
            @close="$refs.productTable.toggleRowSelection(item)"
            closable
            type="success"
            style="margin-right: 10px"
            v-for="(item, index) in selectList"
            :key="item.id"
            >{{
              ` ${index + 1}、${item.product_name}(${item.product_size}) `
            }}</el-tag
          >
          <el-tag
            type="primary"
            style="margin-right: 10px; cursor: pointer"
            @click="$refs['productTable'].clearSelection()"
            >清空</el-tag
          >
        </span>
      </div>
    </el-alert>
    <el-table
      ref="productTable"
      :data="productTableData"
      border
      highlight-current-row
      v-loading="tableLoading"
      @sort-change="sortChange"
      @selection-change="
        (selection) => {
          selectList = selection;
        }
      "
      @row-click="
        (row) => {
          $refs.productTable.toggleRowSelection(row);
        }
      "
      :row-key="(row) => row.id"
    >
      <el-table-column
        :reserve-selection="true"
        type="selection"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="customer_name"
        label="客户名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="product_name"
        label="产品名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="product_size"
        label="产品规格"
        align="center"
        sortable="custom"
      ></el-table-column>
      <el-table-column label="生产流程" align="center" min-width="250px">
        <template slot-scope="scope">
          <div
            v-for="(item, index) in scope.row.process"
            :key="index"
            style="text-align: left"
          >
            <div>
              <span>{{
                `${
                  [
                    "一",
                    "二",
                    "三",
                    "四",
                    "五",
                    "六",
                    "七",
                    "八",
                    "九",
                    "十",
                    "十一",
                    "十二",
                  ][index]
                }、${item.description}`
              }}</span>
              <span v-if="item.hour !== null && item.hour != 0">{{
                `[日产:${item.hour}]`
              }}</span>
              <span v-if="item.price !== null && item.price !== 0">{{
                `[单价:${item.price}]`
              }}</span>
            </div>
            <span v-for="(req, idx) in item.require.split(/;|；/)" :key="idx">
              <span v-if="req !== ''">
                <span
                  v-if="req.indexOf('/') === -1"
                  style="display: inline-block"
                  >{{
                    [
                      "①",
                      "②",
                      "③",
                      "④",
                      "⑤",
                      "⑥",
                      "⑦",
                      "⑧",
                      "⑨",
                      "⑩",
                      "⑪",
                      "⑫",
                    ][idx] + req.replace("@", "↧").replace("^", "φ")
                  }}</span
                >
                <span style="display: inline-block" v-else>
                  <span style="display: inline-block; text-align: right">{{
                    [
                      "①",
                      "②",
                      "③",
                      "④",
                      "⑤",
                      "⑥",
                      "⑦",
                      "⑧",
                      "⑨",
                      "⑩",
                      "⑪",
                      "⑫",
                    ][idx] +
                    req.split(/[+|-]/)[0].replace("@", "↧").replace("^", "φ")
                  }}</span>
                  <span
                    style="
                      position: relative;
                      width: 50px;
                      display: inline-block;
                    "
                  >
                    <sup
                      style="
                        position: absolute;
                        left: 0px;
                        bottom: 5px;
                        width: 40px;
                        display: inline-block;
                        line-height: 10px;
                        text-align: left;
                      "
                      >{{
                        req.match(/[+|-]/)
                          ? req.match(/[+|-]/)[0] +
                            req.split(/[+|-]/)[1].split("/")[0]
                          : "输入不符合规范"
                      }}</sup
                    >
                    <sub
                      style="
                        position: absolute;
                        left: 2px;
                        top: -5px;
                        width: 40px;
                        display: inline-block;
                        line-height: 10px;
                        text-align: left;
                      "
                      >{{ req.match(/\/(.)/)[1] + req.split(/[+|-]/)[2] }}</sub
                    >
                  </span>
                </span>
              </span>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="face"
        label="表面处理"
        align="center"
      ></el-table-column>
      <el-table-column
        label="图片"
        align="center"
      >
        <template slot-scope="scope">
          <el-image
            v-for="(item, index) in scope.row.imgList"
            :key="index"
            style="width: 100px; height: 100px"
            :src="item"
            :preview-src-list="scope.row.imgList">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="100px">
        <template slot-scope="scope">
          <el-link type="primary" @click.stop="showEdit(scope.row)"
            >编辑</el-link
          >
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm
            confirmButtonText="确认"
            cancelButtonText="取消"
            icon="el-icon-warning-outline"
            iconColor="red"
            title="确定删除吗？"
            @click.native="
              (e) => {
                e.stopPropagation();
              }
            "
            @onConfirm="deleteProduct(scope.row.id)"
          >
            <el-link slot="reference" type="primary">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 15px"
      :total="productTableTotal"
      :current-page.sync="searchForm.page"
      @current-change="
        (page) => {
          this.searchForm.page = page;
          this.getList();
        }
      "
      @size-change="
        (size) => {
          this.searchForm.pageSize = size;
          this.searchForm.page = 1;
          this.getList();
        }
      "
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      layout="prev, pager, next, ->, total, sizes"
      align="center"
    ></el-pagination>
    <!-- 添加产品对话框 -->
    <el-dialog
      title="添加产品"
      :visible.sync="addProductVisible"
      width="700px"
      @close="
        $refs.addForm.resetFields();
        addForm.process = [
          { description: '', require: '', hour: '', price: '' },
        ];
      "
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :model="addForm" label-width="250px">
        <el-form-item prop="customer_name" label="客户名称">
          <el-select
            placeholder="客户"
            v-model="addForm.customer_name"
            size="small"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in $store.state.customerNameList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="product_name"
          label="产品名称"
          :rules="{
            required: true,
            message: '产品名称不能为空',
            trigger: 'change',
          }"
        >
          <el-autocomplete
            size="small"
            v-model="addForm.product_name"
            :fetch-suggestions="
              (query, cb) => {
                cb(
                  query
                    ? this.$store.state.productNameList
                        .map((ele) => {
                          return { value: ele };
                        })
                        .filter((item) => item.value.indexOf(query) !== -1)
                    : this.$store.state.productNameList.map((ele) => {
                        return { value: ele };
                      })
                );
              }
            "
            placeholder="品名"
            :clearable="true"
            style="width: 200px"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item prop="product_size" label="产品规格">
          <el-autocomplete
            size="small"
            v-model="addForm.product_size"
            :fetch-suggestions="
              (query, cb) => {
                cb(
                  query
                    ? this.$store.state.productSizeList
                        .map((ele) => {
                          return { value: ele };
                        })
                        .filter((item) => item.value.indexOf(query) !== -1)
                    : this.$store.state.productSizeList.map((ele) => {
                        return { value: ele };
                      })
                );
              }
            "
            placeholder="规格"
            :clearable="true"
            style="width: 200px"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item prop="face" label="表面处理">
          <el-select
            placeholder="表面处理"
            v-model="addForm.face"
            size="small"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in $store.state.faceList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <div
          v-for="(processItem, processIndex) in addForm.process"
          :key="processIndex"
        >
          <el-form-item
            :label="`生产流程 ${processIndex + 1}`"
            :prop="`process.${processIndex}.description`"
            :rules="
              processIndex !== 0 ||
              processItem.hour ||
              (addForm.process.length > 1 && processIndex === 0)
                ? {
                    required: true,
                    message: '流程描述不能为空',
                    trigger: 'blur',
                  }
                : []
            "
          >
            <el-select
              placeholder="加工步骤"
              v-model="processItem.description"
              size="small"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in $store.state.processesList"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
            <el-tooltip effect="dark" content="增加一项流程" placement="top">
              <i
                @click="
                  addForm.process.splice(processIndex + 1, 0, {
                    description: '',
                    require: '',
                    hour: '',
                    price: '',
                  })
                "
                class="el-icon-circle-plus-outline"
                style="
                  color: #409eff;
                  font-size: 28px;
                  vertical-align: middle;
                  margin-left: 5px;
                  cursor: pointer;
                "
              ></i>
            </el-tooltip>
            <el-tooltip
              v-if="processIndex !== 0"
              effect="dark"
              content="删除该流程"
              placement="top"
            >
              <i
                @click="addForm.process.splice(processIndex, 1)"
                class="el-icon-delete"
                style="
                  color: #f56c6c;
                  font-size: 28px;
                  vertical-align: middle;
                  margin-left: 5px;
                  cursor: pointer;
                "
              ></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item :prop="`process.${processIndex}.require`">
            <el-input
              v-model="processItem.require"
              size="small"
              style="width: 200px"
              :clearable="true"
              placeholder="工艺要求"
              type="textarea"
            ></el-input>
            <el-alert
              class="product-dialog-alert"
              v-if="processIndex === 0"
              style="height: 20px; width: 370px; margin-top: 5px"
              type="info"
              :closable="false"
              title="①误差录入规则:+0.01/-0.02 ②字符替代规则:@=>↧，^=>φ"
            ></el-alert>
          </el-form-item>
          <el-form-item :prop="`process.${processIndex}.hour`">
            <el-input
              v-model="processItem.hour"
              size="small"
              style="width: 200px"
              :clearable="true"
              placeholder="日产量"
            ></el-input>
          </el-form-item>
          <el-form-item
            :prop="`process.${processIndex}.price`"
            :rules="{
              pattern: /^[0-9]*(\.[0-9]{1,2})?$/,
              message: '请输入数字(最多两位小数)',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="processItem.price"
              size="small"
              style="width: 200px"
              :clearable="true"
              placeholder="单价"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item prop="remark" label="备注">
          <el-input
            size="small"
            v-model="addForm.remark"
            placeholder="备注"
            style="width: 200px"
            :clearable="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="addProductVisible = false"
          >取消</el-button
        >
        <el-button
          size="small"
          :disabled="buttonDisable"
          type="primary"
          @click="addProduct"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑产品对话框 -->
    <el-dialog
      class="editProductDialog"
      :title="`编辑 (${current.product_name} ${current.product_size})`"
      :visible.sync="editProductVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="editForm" :model="editForm" label-width="250px">
        <el-form-item prop="customer_name" label="客户名称">
          <el-select
            placeholder="客户"
            v-model="editForm.customer_name"
            size="small"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in $store.state.customerNameList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="product_name"
          label="产品名称"
          :rules="{
            required: true,
            message: '产品名称不能为空',
            trigger: 'change',
          }"
        >
          <el-autocomplete
            size="small"
            v-model="editForm.product_name"
            :fetch-suggestions="
              (query, cb) => {
                cb(
                  query
                    ? this.$store.state.productNameList
                        .map((ele) => {
                          return { value: ele };
                        })
                        .filter((item) => item.value.indexOf(query) !== -1)
                    : this.$store.state.productNameList.map((ele) => {
                        return { value: ele };
                      })
                );
              }
            "
            placeholder="品名"
            :clearable="true"
            style="width: 200px"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item prop="size" label="产品规格">
          <el-autocomplete
            size="small"
            v-model="editForm.product_size"
            :fetch-suggestions="
              (query, cb) => {
                cb(
                  query
                    ? this.$store.state.productSizeList
                        .map((ele) => {
                          return { value: ele };
                        })
                        .filter((item) => item.value.indexOf(query) !== -1)
                    : this.$store.state.productSizeList.map((ele) => {
                        return { value: ele };
                      })
                );
              }
            "
            placeholder="规格"
            :clearable="true"
            style="width: 200px"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item prop="face" label="表面处理">
          <el-select
            placeholder="表面处理"
            v-model="editForm.face"
            size="small"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in $store.state.faceList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <div
          v-for="(processItem, processIndex) in editForm.process"
          :key="processIndex"
        >
          <el-form-item
            :label="`生产流程 ${processIndex + 1}`"
            :prop="`process.${processIndex}.description`"
            :rules="
              processIndex !== 0 ||
              processItem.hour ||
              (editForm.process.length > 1 && processIndex === 0)
                ? {
                    required: true,
                    message: '流程描述不能为空',
                    trigger: 'blur',
                  }
                : []
            "
          >
            <el-select
              placeholder="加工步骤"
              v-model="processItem.description"
              size="small"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in $store.state.processesList"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
            <el-tooltip effect="dark" content="增加一项流程" placement="top">
              <i
                @click="
                  editForm.process.splice(processIndex + 1, 0, {
                    description: '',
                    require: '',
                    hour: '',
                    price: '',
                  })
                "
                class="el-icon-circle-plus-outline"
                style="
                  color: #409eff;
                  font-size: 28px;
                  vertical-align: middle;
                  margin-left: 5px;
                  cursor: pointer;
                "
              ></i>
            </el-tooltip>
            <el-tooltip
              v-if="processIndex !== 0"
              effect="dark"
              content="删除该流程"
              placement="top"
            >
              <i
                @click="editForm.process.splice(processIndex, 1)"
                class="el-icon-delete"
                style="
                  color: #f56c6c;
                  font-size: 28px;
                  vertical-align: middle;
                  margin-left: 5px;
                  cursor: pointer;
                "
              ></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item :prop="`process.${processIndex}.require`">
            <el-input
              v-model="processItem.require"
              size="small"
              style="width: 200px"
              :clearable="true"
              placeholder="工艺要求"
              type="textarea"
            ></el-input>
            <el-alert
              class="product-dialog-alert"
              v-if="processIndex === 0"
              style="height: 20px; width: 370px; margin-top: 5px"
              type="info"
              :closable="false"
              title="①误差录入规则:+0.01/-0.02 ②字符替代规则:@=>↧，^=>φ"
            ></el-alert>
          </el-form-item>
          <el-form-item :prop="`process.${processIndex}.hour`">
            <el-input
              v-model="processItem.hour"
              size="small"
              style="width: 200px"
              :clearable="true"
              placeholder="日产量"
            ></el-input>
          </el-form-item>
          <el-form-item
            :prop="`process.${processIndex}.price`"
            :rules="{
              pattern: /^[0-9]*(\.[0-9]{1,2})?$/,
              message: '请输入数字(最多两位小数)',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="processItem.price"
              size="small"
              style="width: 200px"
              :clearable="true"
              placeholder="单价"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item prop="remark" label="备注">
          <el-input
            size="small"
            v-model="editForm.remark"
            placeholder="备注"
            style="width: 200px"
            :clearable="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="imgList">
        <div style="margin:5px;position:relative;display:inline-block" v-for="(item,index) in imgList" :key="index">
          <div class="close" @click="deleteProductPic(item.id)"></div>
          <el-image :src="item.path" />
        </div>
        <el-upload
          class="upload-button"
          :action="baseUrl + '/index/uploadProductPic'"
          name="image"
          :on-success="onAfterUpload"
          :data="{ product_id: current.id }"
          :on-remove="handleRemove"
          :file-list="fileList"
          :show-file-list="false"
          :headers="uploadHeaders"
          list-type="picture"
        >
          <el-button size="small" type="primary">上传产品图片</el-button>
        </el-upload>
      </div>
      <span slot="footer">
        <el-button size="small" @click="editProductVisible = false"
          >取消</el-button
        >
        <el-button size="small" type="primary" @click="editProduct"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看出入库记录对话框 -->
    <el-dialog
      :title="`出入库记录 (${current.product_name} ${current.product_size})`"
      :visible.sync="stockLogVisible"
      width="700px"
    >
      <el-table :data="stockLogTableData" v-loading="stockLogTableLoading">
        <el-table-column
          align="center"
          prop="date"
          label="时间"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="description"
          label="描述"
          width="180px"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.description === '0'">手动设置</div>
            <div v-else-if="scope.row.description === '1'">
              入库操作自动增加
            </div>
            <div v-else-if="scope.row.description === '2'">
              由仓库交付自动减少
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="count"
          label="数量"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="after_number"
          label="操作后库存数"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="account_name"
          label="操作人"
        ></el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 15px"
        v-if="stockLogTableTotal"
        @current-change="
          (page) => {
            this.stockLogPage = page;
            this.getStockLog();
          }
        "
        layout="prev, pager, next"
        :total="stockLogTableTotal"
        align="center"
      ></el-pagination>
      <span slot="footer">
        <el-button size="small" @click="stockLogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getProductList, addProduct, editProduct, getStockLog, deleteProduct, getProductPicById, deleteProductPic } from '../api/index'
import CreateCustomerOrderButton from '../components/CreateCustomerOrderButton'
import CreateProduceButton from '../components/CreateProduceButton'
import CreateProduceReportButton from '../components/CreateProduceReportButton'
import { baseURL, rootUrl } from '../config/App'
console.log(baseURL)
export default {
  name: 'productList',
  components: {
    CreateCustomerOrderButton,
    CreateProduceButton,
    CreateProduceReportButton
  },
  data () {
    return {
      rootUrl: rootUrl,
      baseUrl: baseURL,
      uploadHeaders: {
        Authorization: localStorage.getItem('token')
      },
      // 文件上传图片列表
      fileList: [],
      // 产品列表
      tableLoading: false,
      searchForm: {
        customer_name: '',
        product_name: '',
        product_size: '',
        sortType: 'id',
        order: 'desc',
        page: 1,
        pageSize: 10
      },
      productTableTotal: null,
      productTableData: [],
      selectList: [],
      // 添加产品
      addProductVisible: false,
      buttonDisable: false,
      addForm: {
        customer_name: '',
        product_name: '',
        product_size: '',
        face: '',
        process: [
          {
            description: '',
            require: '',
            hour: '',
            price: ''
          }
        ],
        remark: ''
      },
      // 选中项信息
      current: {},
      // 出入库记录
      stockLogPage: 1,
      stockLogVisible: false,
      stockLogTableData: [],
      stockLogTableTotal: null,
      stockLogTableLoading: false,
      // 编辑
      editProductVisible: false,
      editForm: {
        id: '',
        customer_name: '',
        product_name: '',
        product_size: '',
        face: '',
        process: [
          {
            description: '',
            require: '',
            hour: '',
            price: ''
          }
        ],
        remark: ''
      },
      imgList: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    sortChange (sortInfo) {
      this.searchForm.sortType = sortInfo.prop
      if (sortInfo.order === 'ascending') {
        this.searchForm.order = 'asc'
      } else if (sortInfo.order === 'descending') {
        this.searchForm.order = 'desc'
      } else {
        this.searchForm.sortType = 'id'
        this.searchForm.order = 'desc'
      }
      this.searchForm.page = 1
      this.getList()
    },
    deleteProduct (id) {
      deleteProduct({ id }).then(res => {
        if (res.data.status === 200) {
          this.$message.success(res.data.msg)
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    editProduct () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          editProduct(this.editForm).then(res => {
            console.log(res.data)
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.$refs.editForm.resetFields()
              this.getList()
              this.editProductVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    showEdit (current) {
      console.log(current)
      current = JSON.parse(JSON.stringify(current))
      this.editForm = {
        id: current.id,
        customer_name: current.customer_name,
        product_name: current.product_name,
        product_size: current.product_size,
        face: current.face,
        // stock_number: current,
        // product_price: current,
        process: current.process,
        remark: current.remark
      }
      this.current = current
      this.editForm.process.length === 0 && (this.editForm.process = [{ description: '', require: '', hour: '', price: '' }])
      this.getProductPicById(this.current.id)
      this.editProductVisible = true
    },
    showStockLog (current) {
      this.current = current
      this.getStockLog()
      this.stockLogVisible = true
    },
    getStockLog () {
      this.stockLogTableLoading = true
      getStockLog({ id: this.current.id, page: this.stockLogPage }).then(res => {
        if (res.data.status === 200) {
          this.stockLogTableData = res.data.data
          this.stockLogTableTotal = res.data.total
          this.stockLogTableLoading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    addProduct () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.buttonDisable = true
          addProduct(this.addForm).then(res => {
            this.buttonDisable = false
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.$refs.addForm.resetFields()
              this.getList()
              this.addProductVisible = false
              this.$store.dispatch('getLoginInfo')
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    getList () {
      this.tableLoading = true
      getProductList(this.searchForm).then(res => {
        if (res.data.status === 200) {
          res.data.data.forEach(item => {
            item.imgList.forEach((ele, index) => {
              item.imgList[index] = this.rootUrl + '/static/uploads/' + ele
            })
          })
          this.productTableData = res.data.data
          this.productTableTotal = res.data.total
          this.tableLoading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    productChange (item) {
      let productListSort = JSON.parse(localStorage.getItem('productListSort'))
      if (productListSort) {
        if (productListSort[item]) {
          productListSort[item]++
        } else {
          productListSort[item] = 1
        }
      } else {
        productListSort = {}
        productListSort[item] = 1
      }
      localStorage.setItem('productListSort', JSON.stringify(productListSort))
    },
    onAfterUpload (res) {
      if (res.status === 200) {
        this.$message.success(res.msg)
        this.getProductPicById(this.current.id)
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    getProductPicById (id) {
      getProductPicById({
        product_id: id
      }).then(res => {
        if (res.data.status === 200) {
          res.data.data.forEach(item => {
            item.path = this.rootUrl + '/static/uploads/' + item.path
          })
          this.imgList = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    deleteProductPic (imgId) {
      this.$confirm('是否删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteProductPic({
          img_id: imgId
        }).then(res => {
          if (res.data.status === 200) {
            this.$message.success(res.data.msg)
            this.getProductPicById(this.current.id)
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    }
  }
}
</script>

<style>
.product-list .el-alert__content {
  padding: 0;
}
.product-dialog-alert .el-alert__title {
  font-size: 12px;
}
.editProductDialog .el-dialog__body{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.product-list .imgList {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
}
.product-list .imgList .close{
  position:absolute;
  top:-7px;
  right:-7px;
  width:15px;
  height:15px;
  z-index:1;
  cursor: pointer;
  background-image: url('../assets/close.png');
}
.product-list .imgList img{
  width: 100px;
  height: 100px;
}
.product-list .upload-button{
  display: inline-block;
}
</style>
